import React, {useContext, useEffect, useState} from "react";
import {Bar, BarChart, CartesianGrid, Cell, LabelList, ResponsiveContainer, Tooltip, XAxis, YAxis} from "recharts";
import * as backendUtils from "../helper/BackendUtils";
import AppContext from '../contexts/app-context'
import Sex from "../enums/Sex";
import Category from "../enums/Category";
import {toast} from "react-toastify";

const MEDAL_COLORS = {1: "#FFD700", 2: "#C0C0C0", 3: "#CD7F32"};

const EventBarChart = ({event, email}) => {
    const context = useContext(AppContext);
    const [categories] = useState(event.type === 'counter-commute' ? Category : Sex);
    const [category, setCategory] = useState(null);
    const [chartData, setChartData] = useState([
        {
            "email": "",
            "totalDistance": 0,
            "count": 0
        }
    ]);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (error) {
            console.log(error)
            toast(error)
        }
    }, [error])

    useEffect(() => {
        const loadOpenStats = () => {
            if (context.backendUri && category != null && event) {
                backendUtils.getRequest(`${context.backendUri}/stats/event/${event.id}/${category}`, {},
                    response => {
                        response.data.forEach((d) => {
                            d.email = d.email.slice(0, -22)
                            d.totalDistance = parseFloat(d.totalDistance / 1000).toFixed(1) / 1.0
                        })
                        response.data.sort((a, b) => b.totalDistance - a.totalDistance).sort((a, b) => b.count - a.count)

                        const sortKey = event.type === 'counter-commute' ? 'count' : 'totalDistance';
                        const firstPlaceValue = response.data[0]?.[sortKey] ?? 0;
                        let rank = 1;
                        response.data.forEach((d, i) => {
                            if (i > 0 && d[sortKey] !== response.data[i - 1][sortKey]) rank++;
                            d.rank = rank;
                            const rawDiff = d[sortKey] - firstPlaceValue;
                            d.diff = event.type === 'counter-commute'
                                ? rawDiff
                                : parseFloat(rawDiff.toFixed(1));
                        });

                        setChartData(response.data);
                    },
                    err => {
                        setError(backendUtils.getErrorMessage(err));
                    }
                ).catch((err) => setError(backendUtils.getErrorMessage(err)))
            }
        }
        loadOpenStats()
    }, [context.backendUri, category])

    useEffect(() => {
        const loadCategory = () => {
            if (context.userId && event.id) {
                backendUtils.getRequest(`${context.backendUri}/event/${event.id}/${context.userId}`, {},
                    response => {
                        setCategory(parseInt(response.data.category));
                    },
                    err => {
                        if (err.response.status !== 400) setError(backendUtils.getErrorMessage(err))
                    }
                ).catch((err) => setError(backendUtils.getErrorMessage(err)))
            }
        }
        const loadSex = () => {
            if (context.userId) {
                backendUtils.getRequest(`${context.backendUri}/participant/${context.userId}`, {},
                    response => {
                        setCategory(response.data.sex);
                    },
                    err => {
                        setError(backendUtils.getErrorMessage(err));
                    }
                ).catch((err) => setError(err))
            }
        }
        event.type === 'counter-commute' ? loadCategory() : loadSex();
    }, [context.userId, event.type, event.id])

    return (
        <div className="text-center m-2">
            {
                Object.keys(categories)
                    .map((key) =>
                        <button
                            onClick={() => setCategory(categories[key])}
                            className={category === categories[key] ? 'btn btn-outline-secondary' : 'btn btn-light'}
                            disabled={category === categories[key]}
                        >
                            {key}
                        </button>
                    )
            }
            <ResponsiveContainer width="100%" height={chartData.length * 70}>
                <BarChart layout="vertical" barCategoryGap={10} data={chartData}>
                    <CartesianGrid strokeDasharray="5" horizontal={false} stroke="#ff5800"/>
                    <XAxis
                        tickLine={false}
                        type="number"
                    />
                    <YAxis
                        tickLine={false}
                        dataKey="email"
                        type="category"
                        width={115}
                        tick={(props) => {
                            const {x, y, payload, index} = props;
                            const entry = chartData[index];
                            const rank = entry?.rank ?? index + 1;
                            const color = MEDAL_COLORS[rank] ?? "#ff5800";
                            return (
                                <text x={x} y={y} dy={4} fill={color} fontSize={10} textAnchor="end">
                                    {`#${rank}  ${payload.value}`}
                                </text>
                            );
                        }}
                    />
                    <Tooltip/>
                    <Bar dataKey={event.type === 'counter-commute' ? "count" : "totalDistance"} barSize={24}>
                        {
                            chartData.map((entry, index) =>
                                (
                                    <Cell key={index}
                                          fill={email.includes(chartData[index].email) ? "#00ab64" : "#ff5800"}
                                    />
                                )
                            )
                        }
                        <LabelList
                            dataKey="diff"
                            position="right"
                            style={{fontSize: 10, fill: "#555"}}
                            formatter={(value) => value === 0 ? '' : String(value)}
                        />
                    </Bar>
                </BarChart>
            </ResponsiveContainer>
        </div>
    )
}
export default EventBarChart;